import { render } from "./VersionWindow.vue?vue&type=template&id=2702428b&scoped=true"
import script from "./VersionWindow.vue?vue&type=script&lang=js"
export * from "./VersionWindow.vue?vue&type=script&lang=js"

import "./VersionWindow.vue?vue&type=style&index=0&id=2702428b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2702428b"]])

export default __exports__